import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Styles from './styles.module.css';
// Social svg's import
import { ReactComponent as Logo } from '../../Assets/logo.svg';
import { ReactComponent as SocialYoutube } from '../../Assets/social/social-youtube.svg';
import { ReactComponent as SocialVimeo } from '../../Assets/social/social-vimeo.svg';
import { ReactComponent as SocialDevider } from '../../Assets/social/social-devider.svg';
import { ReactComponent as SocialFacebook } from '../../Assets/social/social-facebook.svg';
import { ReactComponent as SocialInstagram } from '../../Assets/social/social-instagram.svg';
import { ReactComponent as LogoSmall } from '../../Assets/svg/mm_logo_small.svg';
import { ReactComponent as MenuIcon } from '../../Assets/svg/icons-menu.svg';
import { ReactComponent as CloseIcon } from '../../Assets/svg/icon_cancel.svg';

export default class Header extends Component<{},{openMenu:boolean, windowWidth:Number}> {
    constructor(props: any) {
        super(props);

        this.state = {
            openMenu: false,
            windowWidth: window.innerWidth
        }

        this.handleResize = this.handleResize.bind(this);
        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    handleResize(e: any) {
        const width = window.innerWidth;

        if(width > 768){
            this.setState({
                windowWidth: width,
                openMenu: false
            });
        }else{
            this.setState({
                windowWidth: width,
            });
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    render() {
        return (
            <>
                <div className={Styles.container}>
                    <div className={Styles.desktopContainer}>
                        <div className={Styles.social}>
                            <a href="https://www.youtube.com/channel/UC4eePO9PJu1zp2Z3FCg8uMw" target="_blank"><SocialYoutube /></a>
                            <a href="https://vimeo.com/minimalmovie" target="_blank"><SocialVimeo /></a>
                            <SocialDevider className={Styles.devider} height="1.573vw" />
                            <a href="https://www.facebook.com/MinimalMovieProduction" target="_blank"><SocialFacebook /></a>
                            <a href="https://www.instagram.com/minimalmovie/" target="_blank"><SocialInstagram /></a>
                        </div>
                        <div className={Styles.nav}>
                            {/* <Link to="/shop">Shop</Link> */}
                            <Link to="/about">About us</Link>
                            <Link to="/contact">Contact us</Link>
                        </div>
                        <Link to="/"><Logo className={Styles.logo} /></Link>
                    </div>
                    <div className={Styles.mobileContainer}>
                        <Link to="/"><LogoSmall className={Styles.logoMobile} /></Link>
                        <MenuIcon className={Styles.openMenu} onClick={this.openMenu}/>
                    </div>
                </div>
                <div className={Styles.menu} hidden={!this.state.openMenu}>
                    <div className={Styles.container}>
                        <div className={Styles.mobileContainer}>
                            <Link to="/"><LogoSmall className={Styles.logoMobile} /></Link>
                            <CloseIcon className={Styles.openMenu} onClick={this.closeMenu}/>
                        </div>
                    </div>
                    <ul className={Styles.menuItemsContainer}>
                        <li><Link to="/" onClick={this.closeMenu}>Home</Link></li>
                        {/* <li><Link to="/shop" onClick={this.closeMenu}>Shop</Link></li> */}
                        <li><Link to="/about" onClick={this.closeMenu}>About us</Link></li>
                        <li><Link to="/contact" onClick={this.closeMenu}>Contact us</Link></li>
                    </ul>
                </div>
            </>
        )
    }

    openMenu(){
        this.setState({
            openMenu: true
        })
    }

    closeMenu(){
        this.setState({
            openMenu: false
        })
    }
}